/**
 * @vuepress
 * ---
 * title: followupTransformer
 */

import Transformer from '@/transformers/transformer'
import { attachMissingCurrentTime } from '@/utils/moment'
import { parentPrefixTransformer } from '@/transformers/utils'
import { minimalSinister, minimalAffected } from '@/transformers/sinister'

/**
 * @class followupTransformer
 * @author José Luis Ruiz
 */

const userFullName = ({ treatment, name, first_name: firstName, last_name: lastName, mothers_last_name: secondLastName, username }) =>
  `${treatment || ''} ${firstName || name || username} ${lastName || ''} ${secondLastName || ''}`

class followupTransformer extends Transformer {
  static fetch({
    id,
    affected,
    who_reports: whoReports,
    who_reports_name: whoReportsName,
    who_requests: whoRequests,
    request_date: requestDate,
    reporting_channel: reportingChannel,
    status,
    response,
    promise_date: promiseDate,
    closure_date: closureDate,
    observations,
    add_date: addDate,
    who_responses: whoResponses,
    response_date: responseDate,
    missing_attention_first_encounter: missingAttentionFirstEncounter,
    settlement_date: settlementDate,
    user_follow_up: userFollowUp,
    folio,
    sinister,
    kind,
    last_escalation_level: lastEscalationLevel
  }) {
    return {
      id,
      whoReportsName,
      whoReports,
      whoRequests,
      requestDate,
      reportingChannel,
      status,
      response,
      responseDate,
      promiseDate,
      closureDate,
      observations,
      addDate,
      whoResponses,
      folio,
      missingAttentionFirstEncounter,
      kind,
      userFollowUpName: userFullName(userFollowUp),
      userFollowUpId: userFollowUp.id,
      settlementDate,
      lastEscalationLevel,
      ...parentPrefixTransformer('affected', affected ? minimalAffected.fetch(affected) : {}),
      ...parentPrefixTransformer('sinister', sinister ? minimalSinister.fetch(sinister) : {})
    }
  }
  static send({
    casualty,
    requestDate,
    whoReports,
    reportingChannel,
    observations,
    whoReportsName,
    missingAttentionFirstEncounter,
    kind

  }) {
    return {
      'affected': casualty,
      'who_reports_name': whoReportsName,
      'request_date': attachMissingCurrentTime(requestDate),
      'who_reports': whoReports,
      'reporting_channel': reportingChannel,
      observations,
      missing_attention_first_encounter: !!missingAttentionFirstEncounter,
      kind
    }
  }
  static response({
    promiseDate,
    response
  }) {
    return {
      response,
      promise_date: attachMissingCurrentTime(promiseDate)
    }
  }
  static update() {}
}
export default followupTransformer
